import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { SpinnerContainer } from './components';
import { AuthProvider } from './providers/AuthProvider';
import { DataLoader } from './providers/DataLoader';
import { AuthRouting } from './pages/Auth/routing';
import { DoctorRouting } from './pages/Doctor/routing';
import { getAccount } from './redux/selectors';
import { PublicRouting } from './pages/Public/routing';
import { RootState } from './redux/store';

function App() {
  const location = useLocation();
  const user = useSelector(getAccount);
  const requiresPasswordChange = useSelector((state: RootState) => state.auth.requiresPasswordChange);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  return (
    <div>
      <AuthProvider>
        {!user ? (
          <Routes>
            {PublicRouting}
            <Route path="/*" element={<AuthRouting />} />
          </Routes>
        ) : requiresPasswordChange ? (
          <Routes>
            <Route path="/change-password" element={<AuthRouting />} />
            <Route path="*" element={<Navigate to="/change-password" replace />} />
          </Routes>
        ) : (
          <DataLoader>
            <DoctorRouting />
          </DataLoader>
        )}
      </AuthProvider>

      <SpinnerContainer />
      <ToastContainer />
    </div>
  );
}

export default App;
